import { OrdersApiRemoteService } from '../../Services/api/orders/orders-service'
import { IOrderEntity, IOrdersRegisteredOnOmieEntity } from '../../Services/api/orders/orders.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ShowOmieOrderDetailsUseCase
implements IFormUsecase<string, IOrdersRegisteredOnOmieEntity> {
  constructor (private readonly ServiceOrdersApi: OrdersApiRemoteService) {}
    

  public async handle (
    orderId: string
  ): Promise<Result<IOrdersRegisteredOnOmieEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ServiceOrdersApi.showDetails(orderId)

      if (response.isFailure) {
        return response
      }

      const content = response.getValue()

      if(!content) return response

    
      return Result.ok(content)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
